import { param2Obj } from '@/utils/tools'

const tokens = {
    admin: {
        token: 'admin-token'
    },
    editor: {
        token: 'editor-token'
    }
}

const users = {
    'admin-token': {
        roles: ['admin'],
        info: {
            introduction: 'I am a super administrator',
            avatar: 'https://wpimg.wallstcn.com/f778738c-e4f8-4870-b634-56703b4acafe.gif',
            name: '超级管理员'
        },
        menus: [
            {
                path: '/main',
                name: 'Main',
                meta: {
                    title: '首页',
                },
                redirect: '/home',
                parentName: 'root',
                component: 'layout/index',
                children: [
                    {
                        path: '/home',
                        name: "Home",
                        icon: 'list',
                        meta: {
                            title: '项目列表',
                        },
                        parentName: 'Main',
                        component: 'views/home/index'
                    },

                    // 首页 -- 审核列表
                    {
                        path: "/home-audit",
                        name: 'Home-audit',
                        meta: {
                            title: '审核列表',
                        },
                        parentName: 'Main',
                        icon: 'shenhe',
                        component: 'views/home-audit/index',
                        children: [
                            {
                                path: '/', // 默认指向上一级
                                name: 'Home-audit',
                                meta: {
                                    title: '',
                                },
                                hidden: true,
                                parentName: 'Home-audit',
                                component: 'views/home-audit/audit_home'
                            },

                            // 首页 -- 审核详情
                            {
                                path: "/home-audit-detail",
                                name: 'Home-audit-detail',
                                meta: {
                                    title: '审核详情',
                                },
                                hidden: true,
                                parentName: 'Home-audit',
                                icon: 'shenhe',
                                component: 'views/home-audit/audit_detail'
                            }
                        ]
                    },

                    // 图标管理
                    {
                        path: "/icon-management",
                        name: 'Icon-management',
                        meta: {
                            title: '图标管理',
                        },
                        parentName: 'Main',
                        icon: 'icon',
                        component: 'views/icon/icon_management'
                    },

                    // 首页 -- 系统管理
                    {
                        path: '/system-management',
                        name: 'System-management',
                        meta: {
                            title: '系统管理',
                        },
                        parentName: 'Main',
                        icon: 'component',
                        component: 'views/system-management/index',
                        redirect: '/user-management',   // 默认指向用户管理
                        children: [
                            // 用户管理
                            {
                                path: '/user-management',
                                name: 'User-management',
                                meta: {
                                    title: '用户管理',
                                },
                                parentName: 'System-management',
                                icon: 'user',
                                component: 'views/system-management/user/user_management'
                            },

                            // 用户组管理
                            {
                                path: '/user-group-management',
                                name: 'User-group-management',
                                meta: {
                                    title: '用户组管理',
                                },
                                parentName: 'System-management',
                                icon: 'peoples',
                                component: 'views/system-management/user-group/user_group_management'
                            },

                            // 菜单管理
                            {
                                path: '/menu-management',
                                name: 'Menu-management',
                                meta: {
                                    title: '菜单管理',
                                },
                                parentName: 'System-management',
                                icon: 'table',
                                component: 'views/system-management/menu/menu_management'
                            },

                            // 菜单-接口管理
                            {
                                path: '/menu-interface-management',
                                name: 'Menu-interface-management',
                                meta: {
                                    title: '接口管理',
                                },
                                parentName: 'System-management',
                                icon: 'international',
                                component: 'views/system-management/menu-interface/menu_interface_management'
                            },

                            // 权限管理
                            {
                                path: '/permission-management',
                                name: 'Permission-management',
                                meta: {
                                    title: '权限管理',
                                },
                                parentName: 'System-management',
                                icon: 'tree-table',
                                component: 'views/system-management/permission/permission_management'
                            },

                            // 角色管理
                            {
                                path: '/role-management',
                                name: 'Role-management',
                                meta: {
                                    title: '角色管理',
                                },
                                parentName: 'System-management',
                                icon: 'theme',
                                component: 'views/system-management/role/role_management'
                            },
                            // 字典管理
                            {
                                path: '/dict-management',
                                name: 'Dict-management',
                                meta: {
                                    title: '字典管理',
                                },
                                parentName: 'System-management',
                                icon: 'form',
                                component: 'views/system-management/dict/dict_management'
                            },

                        ]
                    },

                    // 首页 -- 组件样例
                    {
                        path: '/components-sample',
                        name: 'Components-sample',
                        meta: {
                            title: '组件样例',
                        },
                        parentName: 'Main',
                        icon: 'sample',
                        component: 'views/components-sample/index',
                        redirect: '/tree-select',   // 默认指向用户管理
                        children: [
                            // tree-select 组件
                            {
                                path: '/tree-select',
                                name: 'Tree-select',
                                meta: {
                                    title: 'treeSelect 组件',
                                },
                                parentName: 'Components-sample',
                                icon: 'tree-select',
                                component: 'views/components-sample/tree-select/tree_index'
                            },

                        ]
                    }
                ]
            }
        ]
    },
    'editor-token': {
        roles: ['editor'],
        info: {
            introduction: 'I am an editor',
            avatar: 'https://wpimg.wallstcn.com/f778738c-e4f8-4870-b634-56703b4acafe.gif',
            name: '路人甲'
        },
        menus: [
            {
                path: '/main',
                name: 'Main',
                meta: {
                    title: '首页',
                },
                redirect: '/home',
                parentName: 'root',
                component: 'layout/index',
                children: [
                    {
                        path: '/home',
                        name: "Home",
                        icon: 'component',
                        meta: {
                            title: '项目列表',
                        },
                        parentName: 'Main',
                        component: 'views/home/index'
                    },
                ]
            }
        ]
    }
}

export default [
    // 用户登录
    {
        url: '/sysUser/login',
        type: 'post',
        response: config => {
            // config 包含接口的 url, type, body
            const { username } = JSON.parse(config.body)
            // token 和 个人信息
            const res_token = tokens[username] ? tokens[username].token : null

            // 模拟错误情况，用户名、密码不正确
            if (!res_token) {
                return {
                    code: 600,
                    msg: '登录名 或者 密码不正确，请重新输入'
                }
            }

            // 成功登录
            return {
                code: 0,
                msg: '执行成功',
                data: {
                    token: res_token
                }
            }
        }
    },

    // 用户信息
    {
        url: 'sysUser/info',
        type: 'get',
        response: config => {
            // 获取接口请求的 地址栏token 参数
            const { token } = param2Obj(config.url)
            // const info = users['999']  // mock error
            const info = users[token]

            // mock error
            if (!info) {
                return {
                    code: 601,
                    msg: '登录失败, 用户信息不存在!'
                }
            }

            return {
                code: 0,
                msg: '执行成功',
                data: info
            }
        }
    },

    // 用户退出
    {
        url: 'sysUser/logout',
        type: 'post',
        response: config => {
            return {
                code: 0,
                data: 'success',
                msg: '退出成功!'
            }
        }
    }
]
